import type { IconSvgObject } from './types';

const HeartOffIcon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.7997 14.5C21.0808 12.7942 22 10.9546 22 9.19444C22 6.32563 19.8947 4 17 4C15.5 4 14 4.5 12 6.5C11.0765 5.57646 10.2595 4.97277 9.5 4.59046", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 17.5945C15.7619 18.7725 14.5238 19.7689 13.5893 20.4677C12.6399 21.1776 11.3601 21.1776 10.4107 20.4677C7.58942 18.358 2 13.5348 2 9.19445C2 7.24649 2.97064 5.54898 4.5 4.65991", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HeartOffIcon;
